import * as React from 'react';
import { ToggleButton } from '@progress/kendo-react-dateinputs';

/**
 * A toggle button to open calendar.
 *
 * @typedef {React.ComponentProps<ToggleButton>} TelerikToggleButtonProps
 *
 * @param {TelerikToggleButtonProps} props Component props. Extends Telerik ToggleButton props.
 * @returns {React.ReactElement} Toggle button to open calendar component.
 */
const CustomToggleButton = (props) => <ToggleButton {...props} tabIndex={-1} />;

export default CustomToggleButton;
